import { oidcEarlyInit } from "oidc-spa/entrypoint";

const { shouldLoadApp } = oidcEarlyInit({
   browserRuntimeFreeze: undefined,

   BASE_URL: "/"
});

if (shouldLoadApp) {
    import("./main.tsx?oidc-spa-original=true");
}